export const API_URL = "https://deafministryrwanda.org/dmrapi";

export enum APP_SETTINGS {
  MAX_DOCUMENT_UPLOAD = 2200,
}
